var render, staticRenderFns
import script from "./NgList.vue?vue&type=script&lang=js&"
export * from "./NgList.vue?vue&type=script&lang=js&"
import style0 from "./NgList.vue?vue&type=style&index=0&id=39fe6b4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe6b4f",
  null
  
)

export default component.exports